(() => {
  const root = document.querySelector("[data-ms-plus]");
  if (!root) return;

  /* ── Module filters ── */
  const filters = root.querySelectorAll("[data-ms-module-filter]");
  const grids = root.querySelectorAll("[data-ms-module-grid]");
  filters.forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.getAttribute("data-ms-module-filter");
      filters.forEach((b) => {
        const on = b === btn;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      grids.forEach((g) => {
        const match = g.getAttribute("data-ms-module-grid") === id;
        g.hidden = !match;
        g.classList.toggle("is-active", match);
      });
    });
  });

  /* ── FAQ accordion ── */
  root.querySelectorAll("[data-ms-faq-item]").forEach((item) => {
    const trigger = item.querySelector("[data-ms-faq-trigger]");
    const panel = item.querySelector("[data-ms-faq-panel]");
    if (!trigger || !panel) return;
    trigger.addEventListener("click", () => {
      const open = item.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
      panel.hidden = !open;
    });
  });

  /* ── Review carousel ── */
  const track = root.querySelector("[data-ms-reviews-track]");
  const prev = root.querySelector("[data-ms-reviews-prev]");
  const next = root.querySelector("[data-ms-reviews-next]");
  if (track) {
    const scrollBy = (dir) => {
      const card = track.querySelector(".ms-plus-review");
      const amount = card ? card.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: dir * amount, behavior: "smooth" });
    };
    prev?.addEventListener("click", () => scrollBy(-1));
    next?.addEventListener("click", () => scrollBy(1));
  }

  /* ── UGC video carousel ── */
  const ugc = root.querySelector("[data-ms-ugc-track]");
  const ugcDots = root.querySelectorAll("[data-ms-ugc-dot]");
  if (ugc) {
    const cards = [...ugc.querySelectorAll(".ms-plus-ugc-card")];
    const goTo = (idx) => {
      const card = cards[idx];
      if (!card) return;
      card.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      ugcDots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
    };
    ugcDots.forEach((dot, i) => dot.addEventListener("click", () => goTo(i)));

    ugc.querySelectorAll("[data-ms-ugc-play]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const card = btn.closest(".ms-plus-ugc-card");
        const video = card?.querySelector("video");
        if (!video) return;
        ugc.querySelectorAll("video").forEach((v) => {
          if (v !== video) {
            v.pause();
            v.closest(".ms-plus-ugc-card")?.classList.remove("is-playing");
          }
        });
        if (video.paused) {
          video.muted = false;
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
          card.classList.add("is-playing");
        } else {
          video.pause();
          card.classList.remove("is-playing");
        }
      });
    });

    ugc.querySelectorAll("[data-ms-ugc-mute]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const video = btn.closest(".ms-plus-ugc-card")?.querySelector("video");
        if (!video) return;
        video.muted = !video.muted;
        btn.setAttribute("aria-pressed", video.muted ? "true" : "false");
        btn.textContent = video.muted ? "Unmute" : "Mute";
      });
    });
  }

  /* ── Quality showcase videos autoplay when visible ── */
  const qualityVideos = root.querySelectorAll("[data-ms-quality-video]");
  if (qualityVideos.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          if (entry.isIntersecting) {
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.35 }
    );
    qualityVideos.forEach((v) => io.observe(v));
  }

  /* ── How-it-works step reveal ── */
  const steps = root.querySelectorAll("[data-ms-step]");
  if (steps.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.25 }
    );
    steps.forEach((s) => io.observe(s));
  }
})();
